import React from 'react';
import { motion } from 'framer-motion';
import PageTemplate from './PageTemplate';

import '../../../../assests/css/customer/Footer/Payments.css';
import MyNavbar from '../../Mynavbar/MyNavbar';
import Footer from '../Footer';

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const CONTACT_EMAIL = 'wecare@moonlitonline.pk';
const CONTACT_PHONE = '+92(0)42 111-738-245';

const Payments = () => {
  return (
    <>
      <MyNavbar />
      
      <div className="payments-container">
        <motion.h1 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="payments-title"
        >
          Payment Methods
        </motion.h1>

        <motion.div
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.6, ease: 'easeOut' }}
          variants={{
            visible: { transition: { staggerChildren: 0.12 } }
          }}
        >
          <PaymentBlock title="Overview">
            At Moonlit, we prioritize your convenience and security. We offer multiple payment methods that are fully encrypted and compliant with international security standards, ensuring a safe and seamless checkout experience.
          </PaymentBlock>

          <PaymentBlock title="Cash On Delivery (COD)">
            Our Cash on Delivery service provides flexibility and peace of mind for customers who prefer to pay upon receiving their order.
            <ul>
              <li>Available for deliveries across Pakistan</li>
              <li>Payment is made in cash directly to the courier at the time of delivery</li>
              <li>Inspect your order before making payment</li>
              <li>No advance payment or card details required</li>
            </ul>
            <div className="payment-note">
              <strong>Note:</strong>
              Please ensure you have the exact amount ready to facilitate a smooth delivery process.
            </div>
          </PaymentBlock>

          <PaymentBlock title="Online Payments - Credit & Debit Cards">
            We accept secure online payments through trusted and verified payment gateways. All transactions are protected with end-to-end encryption and 3-D Secure authentication, adding an extra layer of security to your purchases.
            <ul>
              <li><strong>Supported Cards:</strong> Visa and MasterCard credit and debit cards</li>
              <li><strong>Payment Gateway:</strong> Bank Al Falah's secure payment platform</li>
              <li><strong>3-D Secure Protection:</strong> Your card details are authenticated through an additional verification step</li>
              <li><strong>SSL Encryption:</strong> All payment information is encrypted during transmission</li>
            </ul>
            <div className="payment-icons">
              <span className="payment-icon">VISA</span>
              <span className="payment-icon">MASTERCARD</span>
            </div>
            <p style={{ marginTop: '1rem' }}>
              You will be redirected to Bank Al Falah's secure payment portal to complete your transaction. Your card information is never stored on our servers.
            </p>
          </PaymentBlock>

          <PaymentBlock title="Payment Security">
            Your financial security is our top priority. We comply with PCI-DSS (Payment Card Industry Data Security Standard) requirements and use advanced encryption technology to protect your payment information at every step of the transaction process.
          </PaymentBlock>

          <PaymentBlock title="Chargebacks & Refunds">
            In the event of a chargeback or refund request:
            <ul>
              <li>Contact your bank or card issuer directly for chargeback assistance</li>
              <li>Reach out to our customer support team for refund inquiries</li>
              <li>Provide your order number and transaction details for faster processing</li>
            </ul>
            <p>
              <strong>For assistance:</strong> Call us at{' '}
              <a href={`tel:${CONTACT_PHONE}`} aria-label="Call Moonlit">
                {CONTACT_PHONE}
              </a>{' '}
              or email us at{' '}
              <a href={`mailto:${CONTACT_EMAIL}`} aria-label="Email Moonlit">
                {CONTACT_EMAIL}
              </a>.
            </p>
          </PaymentBlock>

          <PaymentBlock title="Order Confirmation">
            Once your payment is successfully processed, you will receive an order confirmation email with your order details and estimated delivery timeline. If you do not receive this confirmation within 24 hours, please contact our support team.
          </PaymentBlock>
        </motion.div>
      </div>
      
      <Footer />
    </>
  );
};

const PaymentBlock = ({ title, children }) => (
  <motion.section variants={fadeUp} className="payment-block">
    <h3>{title}</h3>
    <div className="payment-text">{children}</div>
  </motion.section>
);

export default Payments;